import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('maintenancePage');

    return {
        ACKNOWLEDGE: t('acknowledge'),
        ACTIVE_WARNINGS: t('activeWarnings'),
        ADD_NOTE: t('addNote'),
        ADD_TO_CART: t('addToCart'),
        AIRWORTHY_DEFINITION_GROUNDED: t('airworthyDefinitionGrounded'),
        AIRWORTHY_DEFINITION_HOLD: t('airworthyDefinitionHold'),
        AIRWORTHY_DEFINITION_READY: t('airworthyDefinitionReady'),
        AIRWORTHY_SET_BY: (params: { status: string; who: string; when: string }): string =>
            t('airworthySetBy', params),
        BATTERY_CURRENT: t('batteryCurrent'),
        BATTERY_CYCLES: t('batteryCycles'),
        BATTERY_STATUS_AGING: t('batteryStatusAging'),
        BATTERY_STATUS_DEFINITION_HOLD: t('batteryStatusDefinitionHold'),
        BATTERY_STATUS_DEFINITION_IN_SERVICE: t('batteryStatusDefinitionInService'),
        BATTERY_STATUS_DEFINITION_RETIRED: t('batteryStatusDefinitionRetired'),
        BATTERY_STATUS_HOLD: t('batteryStatusHold'),
        BATTERY_STATUS_IN_SERVICE: t('batteryStatusInService'),
        BATTERY_STATUS_OK: t('batteryStatusOk'),
        BATTERY_STATUS_RETIRED: t('batteryStatusRetired'),
        BATTERY_TEMPERATURE: t('batteryTemperature'),
        BATTERY_VOLTAGE: t('batteryVoltage'),
        CALIBRATION_FLOW: t('calibrationFlow'),
        CALIBRATION_KIND_FLOW: t('calibrationKindFlow'),
        CALIBRATION_KIND_LEVEL: t('calibrationKindLevel'),
        CALIBRATION_KIND_MAGNETOMETER: t('calibrationKindMagnetometer'),
        CALIBRATION_KIND_PUMP: t('calibrationKindPump'),
        CALIBRATION_KIND_WEIGHT: t('calibrationKindWeight'),
        CALIBRATION_LEVEL: t('calibrationLevel'),
        CALIBRATION_MAGNETOMETER: t('calibrationMagnetometer'),
        CALIBRATION_PUMP: t('calibrationPump'),
        CALIBRATION_WEIGHT: t('calibrationWeight'),
        CART_TITLE: t('cartTitle'),
        CELL_VOLTAGES: t('cellVoltages'),
        CHARGE_CYCLES: t('chargeCycles'),
        COMING_SOON: t('comingSoon'),
        COMPONENT_STATUS_DRIFT: t('componentStatusDrift'),
        COMPONENT_STATUS_DUE: t('componentStatusDue'),
        COMPONENT_STATUS_OK: t('componentStatusOk'),
        COMPONENT_STATUS_OVERTEMP: t('componentStatusOvertemp'),
        COMPONENTS_TAB: t('componentsTab'),
        CYCLE_LIFE_LABEL: t('cycleLifeLabel'),
        CYCLES_LABEL: t('cyclesLabel'),
        CYCLES_UNIT: t('cyclesUnit'),
        DRONE_PREFIX: t('dronePrefix'),
        DRONE_SEARCH_PLACEHOLDER: t('droneSearchPlaceholder'),
        DRONE_SERIAL: t('droneSerial'),
        DRONE_STATUS: t('droneStatus'),
        EDIT_SERVICE_CANCEL: t('editServiceCancel'),
        EDIT_SERVICE_SAVE: t('editServiceSave'),
        EDIT_SERVICE_TITLE: t('editServiceTitle'),
        ELECTRICALS_TAB: t('electricalsTab'),
        EM_DASH: t('emDash'),
        EMPTY_CART: t('emptyCart'),
        EVENT_TYPE_CALIBRATED: t('eventTypeCalibrated'),
        EVENT_TYPE_INSPECTED: t('eventTypeInspected'),
        EVENT_TYPE_REPLACED: t('eventTypeReplaced'),
        EVENT_TYPE_SERVICED: t('eventTypeServiced'),
        FAA_PREFIX: t('faaPrefix'),
        FAA_REGISTRATION: t('faaRegistration'),
        FAULT_HISTORY: t('faultHistory'),
        FAULTS_30D: t('faults30d'),
        FILTER_ALL: t('filterAll'),
        FILTER_CAUTION: t('filterCaution'),
        FILTER_CRITICAL: t('filterCritical'),
        FILTER_DUE_SOON: t('filterDueSoon'),
        FILTER_GROUNDED: t('filterGrounded'),
        FIRMWARE_COMPLIANCE: t('firmwareCompliance'),
        FIRMWARE_COMPLIANT: t('firmwareCompliant'),
        FIRMWARE_HISTORY: t('firmwareHistory'),
        FIRMWARE_OUTDATED: t('firmwareOutdated'),
        FIRMWARE_TAB: t('firmwareTab'),
        FIRMWARE_VERSION: t('firmwareVersion'),
        FLEET_HAPPY: t('fleetHappy'),
        FLEET_HEALTH: t('fleetHealth'),
        FLIGHT_HOURS: t('flightHours'),
        HEALTH_TAB: t('healthTab'),
        IDS: t('ids'),
        INTERVAL_CONFIG_CANCEL: t('intervalConfigCancel'),
        INTERVAL_CONFIG_HELPER: t('intervalConfigHelper'),
        INTERVAL_CONFIG_SAVE: t('intervalConfigSave'),
        INTERVAL_CONFIG_TITLE: t('intervalConfigTitle'),
        INTERVAL_INVALID: t('intervalInvalid'),
        INTERVAL_OEM_DEFAULT: (params: { value: string }): string =>
            t('intervalOemDefault', params),
        INTERVAL_RESET_TO_DEFAULT: t('intervalResetToDefault'),
        LAST_INSTALLED: t('lastInstalled'),
        LAST_SERVICE_LINE: (params: { attribution: string; summary: string }): string =>
            t('lastServiceLine', params),
        LAST_SYNC: t('lastSync'),
        LIFECYCLE_DEFINITION_CLAIMED: t('lifecycleDefinitionClaimed'),
        LIFECYCLE_DEFINITION_RELEASED: t('lifecycleDefinitionReleased'),
        LIFECYCLE_SET_BY: (params: { status: string; who: string; when: string }): string =>
            t('lifecycleSetBy', params),
        LOG_SERVICE: t('logService'),
        LOG_SERVICE_CALIBRATION_KIND: t('logServiceCalibrationKind'),
        LOG_SERVICE_CANCEL: t('logServiceCancel'),
        LOG_SERVICE_DATE: t('logServiceDate'),
        LOG_SERVICE_EVENT_TYPE: t('logServiceEventType'),
        LOG_SERVICE_NOTES: t('logServiceNotes'),
        LOG_SERVICE_NOTES_COUNTER: (params: { count: number; max: number }): string =>
            t('logServiceNotesCounter', params),
        LOG_SERVICE_NOTES_PLACEHOLDER: t('logServiceNotesPlaceholder'),
        LOG_SERVICE_PART: t('logServicePart'),
        LOG_SERVICE_PART_CONDITION: t('logServicePartCondition'),
        LOG_SERVICE_PART_SERIAL_NUMBER: t('logServicePartSerialNumber'),
        LOG_SERVICE_PART_SERIAL_NUMBER_PLACEHOLDER: t('logServicePartSerialNumberPlaceholder'),
        LOG_SERVICE_PHOTO_COUNT: (params: { count: number; max: number }): string =>
            t('logServicePhotoCount', params),
        LOG_SERVICE_PHOTO_REMOVE: t('logServicePhotoRemove'),
        LOG_SERVICE_PHOTOS: t('logServicePhotos'),
        LOG_SERVICE_PHOTOS_CTA: t('logServicePhotosCta'),
        LOG_SERVICE_PHOTOS_FORMATS: t('logServicePhotosFormats'),
        LOG_SERVICE_REMAINING_LIFE: t('logServiceRemainingLife'),
        LOG_SERVICE_SAVE: t('logServiceSave'),
        LOG_SERVICE_TITLE: t('logServiceTitle'),
        LOG_SERVICE_UNIT: t('logServiceUnit'),
        LOG_SERVICE_UNIT_NUMBER: (params: { number: number }): string =>
            t('logServiceUnitNumber', params),
        LOG_SYNCED: t('logSynced'),
        MODEL_EXEDY_V9: t('modelExedyV9'),
        MODEL_EXEDY_V12: t('modelExedyV12'),
        MODEL_SELECTOR_LABEL: t('modelSelectorLabel'),
        MOTORS_LABEL: t('motorsLabel'),
        NEVER_RECORDED: t('neverRecorded'),
        NEXT_SERVICE_DUE: t('nextServiceDue'),
        NO_BATTERIES: t('noBatteries'),
        NO_DRONES_MATCH: t('noDronesMatch'),
        NO_FIRMWARE_HISTORY: t('noFirmwareHistory'),
        NO_PARTS_DRONE: t('noPartsDrone'),
        NO_PARTS_FLEET: t('noPartsFleet'),
        NOT_APPLICABLE_NOT_REPORTED: t('notApplicableNotReported'),
        NOT_CONFIGURED: t('notConfigured'),
        OPEN_CART: t('openCart'),
        ORDER_PLACED: t('orderPlaced'),
        OVERVIEW_TAB: t('overviewTab'),
        PAGE_TITLE: t('pageTitle'),
        PART_BATTERY: t('partBattery'),
        PART_CONDITION_NEW: t('partConditionNew'),
        PART_CONDITION_USED: t('partConditionUsed'),
        PART_ESC: t('partEsc'),
        PART_FLOW_METER: t('partFlowMeter'),
        PART_MOTOR: t('partMotor'),
        PART_NOZZLE_SET: t('partNozzleSet'),
        PART_PROP_SET: t('partPropSet'),
        PART_PUMP_SEAL_KIT: t('partPumpSealKit'),
        PART_RTK_ANTENNA: t('partRtkAntenna'),
        PARTS_TAB: t('partsTab'),
        PLACE_ORDER: t('placeOrder'),
        PRODUCT_BATTERY: t('productBattery'),
        PRODUCT_ESC: t('productEsc'),
        PRODUCT_FLOW_METER: t('productFlowMeter'),
        PRODUCT_MOTOR: t('productMotor'),
        PRODUCT_NOZZLE_SET: t('productNozzleSet'),
        PRODUCT_PROP_SET: t('productPropSet'),
        PRODUCT_PUMP_SEAL_KIT: t('productPumpSealKit'),
        PRODUCT_RTK_ANTENNA: t('productRtkAntenna'),
        PROPS_LABEL: t('propsLabel'),
        PUMP_ROW_LABEL: t('pumpRowLabel'),
        PUMPS_LABEL: t('pumpsLabel'),
        RADAR_BACK: t('radarBack'),
        RADAR_DOWNWARD_TERRAIN: t('radarDownwardTerrain'),
        RADAR_FRONT: t('radarFront'),
        READINESS_GROUNDED: t('readinessGrounded'),
        READINESS_HOLD: t('readinessHold'),
        READINESS_READY: t('readinessReady'),
        RECOMMENDED_PARTS: t('recommendedParts'),
        REMAINING_LIFE_INVALID: (params: { max: number }): string =>
            t('remainingLifeInvalid', params),
        REMOVE: t('remove'),
        RETURN_TO_SERVICE_HELPER: t('returnToServiceHelper'),
        RETURN_TO_SERVICE_KEEP_GROUNDED: t('returnToServiceKeepGrounded'),
        RETURN_TO_SERVICE_KEEP_HOLD: t('returnToServiceKeepHold'),
        RETURN_TO_SERVICE_QUESTION_GROUNDED: (params: { name: string }): string =>
            t('returnToServiceQuestionGrounded', params),
        RETURN_TO_SERVICE_QUESTION_HOLD: (params: { name: string }): string =>
            t('returnToServiceQuestionHold', params),
        RETURN_TO_SERVICE_RETURN: t('returnToServiceReturn'),
        SECTION_BATTERY_PACKS: t('sectionBatteryPacks'),
        SECTION_FIRMWARE: t('sectionFirmware'),
        SECTION_FLOW_METER: t('sectionFlowMeter'),
        SECTION_MOTORS: t('sectionMotors'),
        SECTION_PUMPS: t('sectionPumps'),
        SECTION_RADARS: t('sectionRadars'),
        SECTION_RTK: t('sectionRtk'),
        SERVICE_EVENT_100H_MOTOR: t('serviceEvent100hMotor'),
        SERVICE_EVENT_BATTERY_TEST: t('serviceEventBatteryTest'),
        SERVICE_EVENT_ESC_FIRMWARE: t('serviceEventEscFirmware'),
        SERVICE_EVENT_PROP_ROTATION: t('serviceEventPropRotation'),
        SERVICE_EVENT_PUMP_CALIBRATION: t('serviceEventPumpCalibration'),
        SERVICE_EVENT_PUMP_SEAL: t('serviceEventPumpSeal'),
        SERVICE_HISTORY_EMPTY: t('serviceHistoryEmpty'),
        SERVICE_HISTORY_HEADING: t('serviceHistoryHeading'),
        SERVICE_OVERDUE: t('serviceOverdue'),
        SERVICE_RECORD_BACK: t('serviceRecordBack'),
        SERVICE_RECORD_BY: (params: { who: string; when: string }): string =>
            t('serviceRecordBy', params),
        SERVICE_RECORD_CHANGE_ARROW: t('serviceRecordChangeArrow'),
        SERVICE_RECORD_CHANGE_LOG_HEADING: t('serviceRecordChangeLogHeading'),
        SERVICE_RECORD_CHANGED_BY: (params: { who: string; when: string }): string =>
            t('serviceRecordChangedBy', params),
        SERVICE_RECORD_EDIT: t('serviceRecordEdit'),
        SERVICE_RECORD_INITIAL_USAGE: t('serviceRecordInitialUsage'),
        SERVICE_RECORD_NOTES: t('serviceRecordNotes'),
        SERVICE_RECORD_PART_SERIAL_NUMBER: t('serviceRecordPartSerialNumber'),
        SERVICE_RECORD_PERFORMED_DATE: t('serviceRecordPerformedDate'),
        SERVICE_RECORD_PHOTO_ADDED: t('serviceRecordPhotoAdded'),
        SERVICE_RECORD_PHOTO_REMOVED: t('serviceRecordPhotoRemoved'),
        SERVICE_RECORD_SERIAL_NUMBER: (params: { serialNumber: string }): string =>
            t('serviceRecordSerialNumber', params),
        SERVICE_RECORD_SUMMARY: (params: { event: string; target: string }): string =>
            t('serviceRecordSummary', params),
        SERVICE_RECORD_USAGE_AT_SERVICE: t('serviceRecordUsageAtService'),
        SERVICE_TAB: t('serviceTab'),
        SERVICE_UPCOMING_HEADING: t('serviceUpcomingHeading'),
        SERVICE_VOID: t('serviceVoid'),
        SERVICE_VOIDED_BY: (params: { who: string; when: string }): string =>
            t('serviceVoidedBy', params),
        SERVICE_WHEN_4D: t('serviceWhen4d'),
        SERVICE_WHEN_12D: t('serviceWhen12d'),
        SERVICE_WHEN_21D: t('serviceWhen21d'),
        SERVICE_WHEN_44D: t('serviceWhen44d'),
        SERVICE_WHEN_68D: t('serviceWhen68d'),
        SERVICE_WHEN_100H: t('serviceWhen100h'),
        SINCE_SERVICE_SUFFIX: t('sinceServiceSuffix'),
        STATE_OF_HEALTH: t('stateOfHealth'),
        STATUS_CAUTION: t('statusCaution'),
        STATUS_CLAIMED: t('statusClaimed'),
        STATUS_CRITICAL: t('statusCritical'),
        STATUS_DISABLED: t('statusDisabled'),
        STATUS_ENABLED: t('statusEnabled'),
        STATUS_GOOD: t('statusGood'),
        STATUS_RELEASED: t('statusReleased'),
        STATUS_UPDATED: t('statusUpdated'),
        SUBTOTAL: t('subtotal'),
        TO_SERVICE_SUFFIX: t('toServiceSuffix'),
        TOTAL_ACRES: t('totalAcres'),
        TOTAL_DRONES: t('totalDrones'),
        TOTAL_FLIGHT_HOURS: t('totalFlightHours'),
        UNIT_ACRES: t('unitAcres'),
        UNIT_ALL: t('unitAll'),
        UNIT_DAYS: t('unitDays'),
        UNIT_DAYS_AGO: t('unitDaysAgo'),
        UNIT_FLIGHTS: t('unitFlights'),
        UNIT_FLIGHTS_LOWER: t('unitFlightsLower'),
        UNIT_HOURS: t('unitHours'),
        UNIT_HOURS_SHORT: t('unitHoursShort'),
        UNIT_MOTOR: (params: { number: number }): string => t('unitMotor', params),
        UNIT_PROP_AT_MOTOR: (params: { number: number }): string => t('unitPropAtMotor', params),
        UNIT_PUMP: (params: { number: number }): string => t('unitPump', params),
        URGENCY_DUE_SOON: t('urgencyDueSoon'),
        URGENCY_URGENT: t('urgencyUrgent'),
        USAGE: t('usage'),
        USED_WITH: t('usedWith'),
        VIEW_BATTERIES: t('viewBatteries'),
        VIEW_DRONES: t('viewDrones'),
        VIEW_RECENT_ACTIVITY: t('viewRecentActivity'),
        WARNINGS_TAB: t('warningsTab'),
        WARRANTY: t('warranty'),
        WARRANTY_END: t('warrantyEnd'),
        WARRANTY_EXP_PREFIX: t('warrantyExpPrefix'),
        WARRANTY_EXPIRED: t('warrantyExpired'),
        WARRANTY_REMAINING: t('warrantyRemaining'),
        WARRANTY_START: t('warrantyStart'),
        WATCHING_LABEL: t('watchingLabel')
    };
};

export default useTranslation;
